/* MBR Bundle Builder v3 — mix & match, volume discount by total bottle count.
   The discount itself is owned by Bundler at cart/checkout: this script only
   projects it. Everything renders from the JSON emitted by the section. */
(function () {
  'use strict';

  var DEFAULT_TIERS = [{ qty: 4, pct: 10 }, { qty: 8, pct: 12.5, popular: true }, { qty: 12, pct: 15 }];
  var INK = '#1a1b18', JADE = '#008060', GOLD = '#b48a3c', MUTED = '#73767c';

  function parseJson(str, fallback) {
    if (typeof str !== 'string') return str || fallback;
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function fmt(n) { return '₪' + Math.round(n).toLocaleString('he-IL'); }
  function fmt2(n) { return '₪' + n.toFixed(2); }
  function pctLabel(p) { return (+(+p).toFixed(2)) + '%'; }
  function word(n) { return n === 1 ? 'בקבוק אחד' : (n + ' בקבוקים'); }
  // GA4: the Google & YouTube app puts a configured gtag on the page (G-B0E5X32V2H), so events sent
  // through it land in the same property as page views and purchases. The dataLayer push stays for a
  // future GTM container. The Shopify pixel of the Google app already reports each builder cart
  // update as a standard add_to_cart (verified: /cart/update.js does trigger product_added_to_cart),
  // so only the bundle-specific events are sent here — no duplicate ecommerce events.
  function track(name, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data || {}); } catch (e) {}
    // Microsoft Clarity (app Shopify, tag uypy484dkc): the event lets recordings be filtered by it, the
    // tags let heatmaps be segmented (pack, tier, city eligibility). value/currency are not worth a tag.
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        Object.keys(data || {}).forEach(function (k) { if (k !== 'value' && k !== 'currency') window.clarity('set', k, String(data[k])); });
      }
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.mbrInit) return;
    root.dataset.mbrInit = '1';

    var cfgEl = root.querySelector('[data-mbr-config]');
    var cfg = cfgEl ? parseJson(cfgEl.textContent, null) : null;
    if (!cfg) return;

    var products = (cfg.products || []).filter(function (p) { return p && p.key; });
    if (!products.length) return;

    var tiers = parseJson(cfg.tiersJson, DEFAULT_TIERS)
      .filter(function (t) { return t && +t.qty > 0 && t.pct != null; })
      .map(function (t) { return { qty: +t.qty, pct: +t.pct, popular: !!t.popular }; })
      .sort(function (a, b) { return a.qty - b.qty; });
    if (!tiers.length) tiers = DEFAULT_TIERS.slice();

    var cats = parseJson(cfg.categoriesJson, []).filter(function (c) { return c && c.key; })
      .filter(function (c) { return products.some(function (p) { return p.cat === c.key; }); });
    var showFilters = cats.length > 1;

    var freeThr = +cfg.freeShippingThreshold || 299;
    var maxQty = tiers[tiers.length - 1].qty;
    var minQty = tiers[0].qty;
    var afterAdd = root.dataset.after || 'drawer';
    var showSpecs = root.dataset.specs !== '0';
    var showTagline = root.dataset.tagline !== '0';

    var byKey = {};
    products.forEach(function (p) { byKey[p.key] = p; });

    function isCat(key) { return cats.some(function (c) { return c.key === key; }); }
    var urlCat = null;
    try { urlCat = new URLSearchParams(window.location.search).get('cat'); } catch (e) {}
    var initialFilter = (urlCat && isCat(urlCat)) ? urlCat
      : (cfg.defaultFilter && isCat(cfg.defaultFilter)) ? cfg.defaultFilter : 'all';

    // Ready-made packs sold as one product (e.g. "מארז 4 קוקטיילים"): the builder shows them as their
    // bottles and, on update, replaces the pack line by the bottles the customer actually chose.
    var packs = (cfg.packs || []).filter(function (x) { return x && x.key && x.items && x.items.length; });
    var state = { counts: {}, filter: showFilters ? initialFilter : 'all', lastTier: 0, cartOther: 0, hadCart: false, packLines: {} };
    products.forEach(function (p) { state.counts[p.key] = 0; });

    // ---- helpers on products -------------------------------------------------
    function soldOut(p) {
      if (p.available === false) return true;
      return !!(p.track && !p.cont && typeof p.inv === 'number' && p.inv <= 0);
    }
    function maxFor(p) {
      if (soldOut(p)) return 0;
      if (p.track && !p.cont && typeof p.inv === 'number') return Math.max(0, p.inv);
      return Infinity;
    }
    function count(k) { return state.counts[k] || 0; }
    function shortName(p) { return String(p.he || '').replace(/^קוקטייל ערק /, '').replace(/^ערק /, '').trim() || p.he; }
    function tierPct(n) { var pct = 0; tiers.forEach(function (t) { if (n >= t.qty) pct = t.pct; }); return pct; }
    function visible(p) { return state.filter === 'all' || p.cat === state.filter; }

    // ---- derived values (README "Derived logic") -----------------------------
    function derive() {
      var total = 0, subtotal = 0;
      products.forEach(function (p) { var n = count(p.key); total += n; subtotal += n * (+p.price || 0); });
      // The selection mirrors the cart (bundle products), so tiers count the selection itself.
      var all = total;
      var reached = null;
      for (var i = tiers.length - 1; i >= 0; i--) { if (all >= tiers[i].qty) { reached = tiers[i]; break; } }
      var pct = reached ? reached.pct / 100 : 0;
      var discount = subtotal * pct;
      var finalPrice = subtotal - discount;
      var next = null;
      for (var j = 0; j < tiers.length; j++) { if (all < tiers[j].qty) { next = tiers[j]; break; } }

      var nextMsg;
      if (all === 0) nextMsg = 'הוסיפו בקבוקים כדי לפתוח את ההנחה הראשונה';
      else if (next) nextMsg = 'עוד ' + word(next.qty - all) + ' ל-' + pctLabel(next.pct) + ' הנחה' + (next.qty === maxQty ? ' — המקסימלית' : '');
      else nextMsg = 'קיבלתם את ההנחה המקסימלית — ' + pctLabel(reached.pct);

      var shipBase = finalPrice + state.cartOther;
      var shipDone = shipBase >= freeThr;
      var shipMsg = shipDone ? 'משלוח חינם' : ('עוד ' + fmt(Math.ceil(freeThr - shipBase)) + ' למשלוח חינם');

      var savings = pct > 0
        ? ('חסכתם ' + fmt(discount) + ' · ' + word(total))
        : (total > 0 ? (word(total) + ' · ההנחה נפתחת מ-' + minQty) : ('ההנחה נפתחת מ-' + minQty + ' בקבוקים'));

      return {
        total: total, subtotal: subtotal, reached: reached, pct: pct, discount: discount, finalPrice: finalPrice,
        next: next, nextMsg: nextMsg, shipDone: shipDone, shipMsg: shipMsg, savings: savings,
        progress: Math.min(all / maxQty, 1) * 100
      };
    }

    // ---- DOM refs ------------------------------------------------------------
    var els = {
      packs: root.querySelector('[data-packs]'),
      filters: root.querySelector('[data-filters]'),
      grid: root.querySelector('[data-grid]'),
      total: root.querySelector('[data-total]'),
      bar: root.querySelector('[data-bar]'),
      prog: root.querySelector('[data-prog]'),
      progFill: root.querySelector('[data-prog-fill]'),
      next: root.querySelector('[data-next]'),
      ship: root.querySelector('[data-ship]'),
      thumbs: root.querySelector('[data-thumbs]'),
      cartstate: root.querySelector('[data-cartstate]'),
      final: root.querySelector('[data-final]'),
      sub: root.querySelector('[data-sub]'),
      save: root.querySelector('[data-save]'),
      cta: root.querySelector('[data-cta]'),
      err: root.querySelector('[data-err]'),
      ok: root.querySelector('[data-ok]'),
      note: root.querySelector('[data-note]'),
      reset: root.querySelector('[data-reset]'),
      reviews: root.querySelector('[data-reviews-count]')
    };

    if (els.reviews) {
      var rc = +els.reviews.getAttribute('data-reviews-count');
      if (rc) els.reviews.textContent = rc.toLocaleString('he-IL');
    }

    // Progress ticks at each lower tier (static)
    tiers.slice(0, -1).forEach(function (t) {
      var tick = document.createElement('div');
      tick.className = 'mbr-prog__tick';
      tick.style.right = (t.qty / maxQty * 100) + '%';
      els.prog.appendChild(tick);
    });

    // ---- quick packs ---------------------------------------------------------
    function renderPacks(d) {
      els.packs.innerHTML = tiers.map(function (t, i) {
        var active = d.reached && d.reached.qty === t.qty;
        return '<button type="button" class="mbr-pack' + (active ? ' is-active' : '') + '" data-pack="' + t.qty + '">'
          + (t.popular ? '<span class="mbr-pack__badge">הכי משתלם</span>' : '')
          + '<span class="mbr-pack__qty">' + t.qty + '</span>'
          + '<span class="mbr-pack__unit">בקבוקים</span>'
          + '<span class="mbr-pack__pct" style="color:' + (i === 0 ? GOLD : JADE) + '">' + pctLabel(t.pct) + ' הנחה</span>'
          + '</button>';
      }).join('');
    }

    // A pack targets a total: it tops up the selection round-robin, or trims it down to that total
    // (Jeremy, 10.9.2026: after choosing 8 one could not come back to 4). Trimming takes bottles
    // from the most-counted flavours first, so the variety chosen so far is kept.
    function applyPack(qty) {
      track('bundle_pack_selected', { pack_qty: qty });
      var current = 0;
      products.forEach(function (p) { current += count(p.key); });
      if (current === qty) { celebrate(); return; }
      if (current > qty) { removeQty(current - qty); return; }
      applyQty(qty - current);
    }
    function removeQty(n) {
      var counts = {};
      products.forEach(function (p) { counts[p.key] = count(p.key); });
      while (n > 0) {
        var top = null;
        // Ties go to the LAST product in the catalogue order: the first choices (the cocktails) stay.
        products.forEach(function (p) { if (counts[p.key] > 0 && (!top || counts[p.key] >= counts[top.key])) top = p; });
        if (!top) break;
        counts[top.key]--; n--;
      }
      state.counts = counts;
      render(true);
    }
    // Adds n bottles round-robin over the visible, available products, on top of the selection.
    function applyQty(qty) {
      var candidates = products.filter(function (p) { return visible(p) && !soldOut(p); });
      if (!candidates.length) candidates = products.filter(function (p) { return !soldOut(p); });
      if (!candidates.length) return;
      // Variety first: products not yet selected get a bottle before doubling an existing one.
      candidates = candidates.slice().sort(function (x, y) { return count(x.key) - count(y.key); });
      var counts = {};
      products.forEach(function (p) { counts[p.key] = count(p.key); });
      var remaining = qty, progress = true;
      // Round-robin: one bottle per product per pass → floor(qty/N) each, remainder to the first ones.
      while (remaining > 0 && progress) {
        progress = false;
        for (var i = 0; i < candidates.length && remaining > 0; i++) {
          var c = candidates[i];
          if (counts[c.key] < maxFor(c)) { counts[c.key]++; remaining--; progress = true; }
        }
      }
      state.counts = counts;
      render(true);
    }

    // ---- filters -------------------------------------------------------------
    function renderFilters() {
      if (!showFilters) { els.filters.hidden = true; return; }
      els.filters.hidden = false;
      var chips = [{ key: 'all', he: 'הכל' }].concat(cats);
      els.filters.innerHTML = chips.map(function (c) {
        return '<button type="button" class="mbr-chip' + (state.filter === c.key ? ' is-on' : '') + '" data-filter="' + esc(c.key) + '">' + esc(c.he) + '</button>';
      }).join('');
    }

    // ---- product grid --------------------------------------------------------
    function ctrlHTML(p) {
      var n = count(p.key);
      if (soldOut(p)) return '<button type="button" class="mbr-add" disabled>אזל מהמלאי</button>';
      if (n === 0) return '<button type="button" class="mbr-add" data-inc="' + esc(p.key) + '">הוסף</button>';
      return '<div class="mbr-step">'
        + '<button type="button" data-dec="' + esc(p.key) + '" aria-label="הפחת">−</button>'
        + '<span class="mbr-step__n">' + n + '</span>'
        + '<button type="button" data-inc="' + esc(p.key) + '" aria-label="הוסף"' + (n >= maxFor(p) ? ' disabled' : '') + '>+</button>'
        + '</div>';
    }
    function priceHTML(p, pct) {
      var base = +p.price || 0;
      return (pct > 0 ? '<s class="mbr-card__base">' + fmt2(base) + '</s>' : '')
        + '<span class="mbr-card__unit' + (pct > 0 ? ' is-sale' : '') + '">' + fmt2(base * (1 - pct)) + '</span>';
    }
    function wellHTML(p) {
      var imgs = (p.imgs && p.imgs.length) ? p.imgs : (p.img ? [p.img] : []);
      if (!imgs.length) {
        return '<div class="mbr-card__well"><div class="mbr-card__noimg"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg><span>תמונת מוצר</span></div></div>';
      }
      // One photo on the card; tapping it opens the full-screen viewer with all the photos.
      return '<div class="mbr-card__well"><img src="' + esc(imgs[0]) + '" alt="' + esc(p.he) + '" loading="lazy" data-zoom="' + esc(p.key) + '" data-zoom-i="0"></div>';
    }
    // ---- lightbox (tap a photo → full screen, swipeable) ---------------------
    var lightbox = null;
    function openLightbox(p, index) {
      closeLightbox();
      var imgs = p.imgs && p.imgs.length ? p.imgs : (p.img ? [p.img] : []);
      if (!imgs.length) return;
      lightbox = document.createElement('div');
      lightbox.className = 'mbr-lightbox';
      lightbox.setAttribute('dir', 'rtl');
      lightbox.innerHTML = '<button type="button" class="mbr-lightbox__close" data-lightbox-close aria-label="סגירה"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        + '<div class="mbr-lightbox__title">' + esc(p.he) + '</div>'
        + '<div class="mbr-lightbox__track mbr-scroll" data-lightbox-track>'
        + imgs.map(function (src) { return '<div class="mbr-lightbox__slide"><img src="' + esc(src.replace(/width=600/, 'width=1200')) + '" alt="' + esc(p.he) + '"></div>'; }).join('')
        + '</div>'
        + (imgs.length > 1 ? '<div class="mbr-lightbox__dots">' + imgs.map(function (_, i) { return '<span class="mbr-slider__dot' + (i === index ? ' is-on' : '') + '"></span>'; }).join('') + '</div>' : '');
      document.body.appendChild(lightbox);
      document.documentElement.classList.add('mbr-lightbox-open');
      var track = lightbox.querySelector('[data-lightbox-track]');
      if (index) track.children[index].scrollIntoView({ block: 'nearest', inline: 'start' });
      track.addEventListener('scroll', function () {
        var i = Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
        var dots = lightbox.querySelectorAll('.mbr-slider__dot');
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]') || !e.target.closest('img')) closeLightbox();
      });
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.remove();
      lightbox = null;
      document.documentElement.classList.remove('mbr-lightbox-open');
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

    function badgeHTML(p) {
      if (p.badge === 'best') return '<span class="mbr-card__badge mbr-card__badge--best">הכי נמכר</span>';
      if (p.badge === 'new') return '<span class="mbr-card__badge mbr-card__badge--new">חדש</span>';
      return '';
    }
    var CHECK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
    function taglineHTML(p) {
      if (!showTagline) return '';
      var parts = [p.tag, p.tag2].map(function (t) { return t ? String(t).trim() : ''; }).filter(Boolean);
      if (!parts.length) return '';
      return '<ul class="mbr-card__benefits">' + parts.map(function (t) { return '<li>' + CHECK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul>';
    }
    function specsHTML(p) {
      if (!showSpecs) return '';
      var parts = [];
      if (p.abv != null && p.abv !== '') parts.push((+p.abv % 1 === 0 ? (+p.abv).toFixed(0) : +p.abv) + '% אלכוהול');
      if (p.vol) parts.push(p.vol + ' מ״ל');
      if (p.kosher) parts.push('כשר ' + String(p.kosher).replace(/^כשר\s*/, '').replace(/\s*בית יוסף\s*$/, ''));
      return parts.length ? '<div class="mbr-card__specs">' + parts.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</div>' : '';
    }
    function cardHTML(p, pct) {
      return '<div class="mbr-card' + (soldOut(p) ? ' is-soldout' : '') + '" data-card="' + esc(p.key) + '">'
        + badgeHTML(p)
        + wellHTML(p)
        + '<div class="mbr-card__body">'
        + '<div class="mbr-card__name">' + esc(p.he) + '</div>'
        + taglineHTML(p)
        + specsHTML(p)
        + '<div class="mbr-card__price" data-price>' + priceHTML(p, pct) + '</div>'
        + '<div class="mbr-card__ctrl" data-ctrl>' + ctrlHTML(p) + '</div>'
        + '</div></div>';
    }
    function renderGrid(d) {
      var list = products.filter(visible);
      // Sold-out products go last, otherwise keep the picker order.
      list = list.filter(function (p) { return !soldOut(p); }).concat(list.filter(soldOut));
      els.grid.innerHTML = list.map(function (p) { return cardHTML(p, d.pct); }).join('');
    }
    function updateCards(d) {
      products.forEach(function (p) {
        var card = els.grid.querySelector('[data-card="' + p.key + '"]');
        if (!card) return;
        card.querySelector('[data-price]').innerHTML = priceHTML(p, d.pct);
        card.querySelector('[data-ctrl]').innerHTML = ctrlHTML(p);
      });
    }

    // ---- sticky bar ----------------------------------------------------------
    function renderBar(d) {
      els.total.textContent = d.total;
      els.progFill.style.width = d.progress + '%';
      els.next.textContent = d.nextMsg;
      els.ship.innerHTML = (d.shipDone ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' : '') + esc(d.shipMsg);
      els.ship.style.color = d.shipDone ? JADE : MUTED;

      // What was chosen, in words: the customer must see the flavours behind the total (Jeremy, 10.9.2026).
      var selected = products.filter(function (p) { return count(p.key) > 0; });
      if (selected.length) {
        els.thumbs.hidden = false;
        els.thumbs.innerHTML = '<span class="mbr-sel__lbl">הבחירה שלכם:</span>' + selected.map(function (p) {
          return '<span class="mbr-sel__it">' + esc(shortName(p)) + ' <b>×' + count(p.key) + '</b></span>';
        }).join('') + '<button type="button" class="mbr-sel__clear" data-reset aria-label="נקו הכל">✕ נקו הכל</button>';
      } else {
        els.thumbs.hidden = true;
        els.thumbs.innerHTML = '';
      }
      // What is already in the cart: otherwise « 8 נבחרו » on arrival looks like a bug, not a mirror of the cart.
      if (els.cartstate) {
        if (state.cartBottles > 0) {
          var cp = tierPct(state.cartBottles);
          els.cartstate.hidden = false;
          els.cartstate.innerHTML = 'בעגלה שלכם כבר <b>' + word(state.cartBottles) + '</b>' + (cp ? ' · ' + pctLabel(cp) + ' הנחה' : '') + '. אפשר להוסיף טעמים או לשנות כמויות, ואז ללחוץ על ״עדכון העגלה״.';
        } else {
          els.cartstate.hidden = true;
        }
      }

      els.final.textContent = fmt(d.finalPrice);
      if (d.pct > 0) { els.sub.hidden = false; els.sub.textContent = fmt(d.subtotal); }
      else { els.sub.hidden = true; }
      els.save.textContent = d.savings;
      els.save.style.color = d.pct > 0 ? JADE : MUTED;

      if (els.reset) els.reset.hidden = d.total === 0;
      els.cta.textContent = state.hadCart ? 'עדכון העגלה' : (d.total > 0 ? els.cta.dataset.labelAdd : els.cta.dataset.labelEmpty);
      els.cta.disabled = d.total === 0 && !state.hadCart;
      syncBarHeight();
    }

    // Short green flash on the bar + pulse on the active pack when a tier is unlocked.
    var celebrateTimer = null;
    function celebrate() {
      els.bar.classList.remove('is-hit');
      void els.bar.offsetWidth;
      els.bar.classList.add('is-hit');
      var active = els.packs.querySelector('.mbr-pack.is-active');
      if (active) { active.classList.add('is-hit'); }
      if (navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
      clearTimeout(celebrateTimer);
      celebrateTimer = setTimeout(function () {
        els.bar.classList.remove('is-hit');
        var a = els.packs.querySelector('.mbr-pack.is-hit');
        if (a) a.classList.remove('is-hit');
      }, 900);
    }

    function syncBarHeight() {
      var h = els.bar.offsetHeight + 'px';
      root.style.setProperty('--mbr-bar-h', h);
      document.documentElement.style.setProperty('--mbr-bar-h', h);
    }

    // ---- render --------------------------------------------------------------
    function render(rebuildGrid) {
      var d = derive();
      renderPacks(d);
      if (rebuildGrid) { renderFilters(); renderGrid(d); } else { updateCards(d); }
      renderBar(d);
      var tierQty = d.reached ? d.reached.qty : 0;
      if (tierQty && tierQty !== state.lastTier) {
        track('bundle_tier_reached', { tier_qty: tierQty, tier_pct: d.reached.pct, bottles: d.total });
        if (tierQty > state.lastTier) celebrate();
      }
      state.lastTier = tierQty;
      return d;
    }

    // ---- events --------------------------------------------------------------
    root.addEventListener('click', function (e) {
      var t = e.target;
      var pack = t.closest('[data-pack]');
      var chip = t.closest('[data-filter]');
      var inc = t.closest('[data-inc]');
      var dec = t.closest('[data-dec]');
      if (t.closest('[data-reset]')) {
        products.forEach(function (p) { state.counts[p.key] = 0; });
        clearErr(); render(false); track('bundle_reset', {}); return;
      }
      var zoom = t.closest('[data-zoom]');
      if (zoom) { var zp = byKey[zoom.dataset.zoom]; if (zp) openLightbox(zp, +zoom.dataset.zoomI || 0); return; }
      if (pack) { applyPack(+pack.dataset.pack); return; }
      if (chip) { state.filter = chip.dataset.filter; render(true); return; }
      if (inc) {
        var p = byKey[inc.dataset.inc];
        if (p && count(p.key) < maxFor(p)) state.counts[p.key] = count(p.key) + 1;
        clearErr(); render(false); return;
      }
      if (dec) {
        var k = dec.dataset.dec;
        state.counts[k] = Math.max(0, count(k) - 1);
        clearErr(); render(false);
      }
    });

    function clearErr() { els.err.hidden = true; els.err.textContent = ''; }
    function showErr(msg) { els.err.hidden = false; els.err.textContent = msg; syncBarHeight(); }
    // Confirmation inside the builder itself: the cart drawer may open on its recommendations first.
    var okTimer = null;
    function showOk(msg) {
      if (!els.ok) return;
      els.ok.hidden = false; els.ok.textContent = msg; syncBarHeight();
      clearTimeout(okTimer);
      okTimer = setTimeout(function () { els.ok.hidden = true; syncBarHeight(); }, 5000);
    }
    function showNote(msg) { if (!els.note) return; els.note.hidden = !msg; els.note.textContent = msg || ''; syncBarHeight(); }

    function cartRoutes() {
      var add = '/cart/add.js', cart = '/cart', update = '/cart/update.js';
      if (window.theme && window.theme.routes) {
        if (window.theme.routes.cart_add_url) add = window.theme.routes.cart_add_url;
        if (window.theme.routes.cart_update_url) update = window.theme.routes.cart_update_url;
        if (window.theme.routes.cart_url) cart = window.theme.routes.cart_url;
      } else if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        add = window.Shopify.routes.root + 'cart/add.js';
        update = window.Shopify.routes.root + 'cart/update.js';
        cart = window.Shopify.routes.root.replace(/\/$/, '') + '/cart';
      }
      return { add: add, cart: cart, update: update };
    }

    els.cta.addEventListener('click', function () {
      var updates = {};
      products.forEach(function (p) { updates[p.key] = count(p.key); });
      // A ready-made pack in the cart is replaced by the bottles now selected (its content was pre-selected).
      Object.keys(state.packLines).forEach(function (k) { updates[k] = 0; });
      var d = derive();
      if (d.total === 0 && !state.hadCart) return;
      clearErr();
      els.cta.classList.add('is-loading');
      els.cta.disabled = true;

      var routes = cartRoutes();
      var miniCart = document.querySelector('mini-cart');
      var body = { updates: updates };
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        body.sections = miniCart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
      }

      fetch(routes.update, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          els.cta.classList.remove('is-loading');
          els.cta.disabled = false;
          if (!res.ok) {
            showErr((res.data && (res.data.description || res.data.message)) || 'לא ניתן לעדכן את העגלה');
            return;
          }
          track('bundle_add_to_cart', { bottles: d.total, tier_pct: d.pct * 100, value: Math.round(d.finalPrice * 100) / 100, currency: 'ILS' });
          state.hadCart = d.total > 0;
          state.cartBottles = d.total;
          state.packLines = {};
          showNote('');
          render(false);
          showOk(d.total > 0 ? ('✓ העגלה עודכנה: ' + word(d.total) + (d.pct > 0 ? ' · ' + pctLabel(d.pct * 100) + ' הנחה' : '')) : '✓ הבקבוקים הוסרו מהעגלה');
          if (afterAdd === 'cart') { window.location.href = routes.cart; return; }
          if (miniCart && typeof miniCart.renderContents === 'function' && res.data.sections) {
            miniCart.renderContents(res.data);
          } else {
            window.location.href = routes.cart;
          }
        })
        .catch(function () {
          els.cta.classList.remove('is-loading');
          els.cta.disabled = false;
          window.location.href = routes.cart;
        });
    });

    if (window.ResizeObserver) new ResizeObserver(syncBarHeight).observe(els.bar);
    render(true);

    // URL hint: ?pack=N tops the selection up to that tier (product page links).
    function applyUrlHints() {
      var params = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      var urlPack = +params.get('pack');
      if (urlPack && tiers.some(function (t) { return t.qty === urlPack; })) applyPack(urlPack);
    }

    // The selection mirrors the cart: bottles already in the cart are pre-selected, the customer completes.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bottles = 0, other = 0, packBottles = 0;
        products.forEach(function (p) { state.counts[p.key] = 0; });
        state.packLines = {};
        (cart.items || []).forEach(function (it) {
          var key = byKey[it.variant_id] ? it.variant_id : (byKey[String(it.variant_id)] ? String(it.variant_id) : null);
          if (key) { state.counts[key] += it.quantity; bottles += it.quantity; return; }
          var pack = packs.filter(function (x) { return String(x.key) === String(it.variant_id); })[0];
          if (pack) {
            state.packLines[pack.key] = it.quantity;
            pack.items.forEach(function (k) {
              var kk = byKey[k] ? k : (byKey[String(k)] ? String(k) : null);
              if (kk && count(kk) + it.quantity <= maxFor(byKey[kk])) { state.counts[kk] += it.quantity; bottles += it.quantity; packBottles += it.quantity; }
            });
            return;
          }
          other += (it.final_line_price || it.line_price || 0) / 100;
        });
        state.cartOther = other;
        state.hadCart = bottles > 0;
        state.cartBottles = bottles;
        state.lastTier = 0;
        render(false);
        track('bundle_view', { bottles_in_cart: bottles });
        if (packBottles > 0) showNote('המארז שבעגלה מוצג כאן כ‑' + word(packBottles) + ' — אפשר להחליף טעמים, ובעדכון העגלה הוא יוחלף בבקבוקים שבחרתם.');
      })
      .catch(function () {})
      .then(applyUrlHints);
  }

  function boot() { document.querySelectorAll('.mbr-bb').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
